import { Container, Row, Col, Button, Form } from '@themesberg/react-bootstrap';
import React, { useState, useEffect } from 'react';
import { get, post } from '../../../services/back.service';
import { uploadWithSignedUrl } from '../../../utils/uploadSignedUrl';
import useAutosave from '../../../hooks/useAutosave';

const FormVehiclePicture = ({ id }) => {
  const [bodyImages, setbodyImages] = useState([]);
  const [msgButton, setMsgButton] = useState('Guardar Informacion')

  const autosave = useAutosave(async () => {
    const images = bodyImages.map(({ base64, ...rest }) => rest);
    await post('/peritaje/modifyinspection/pictures/' + id, {
      type: 'CI',
      images
    });
  });

  const updateImages = (name, value) => {
    const tmImages = bodyImages;
    const index = tmImages.findIndex((e) => e.name === name);
    if (index >= 0) {
      tmImages[index] = { ...value, name };
    } else {
      tmImages.push({ ...value, name });
    }
    setbodyImages([...tmImages])
    autosave.schedule();
  };

  const getCurrentImage = (name) => {
    const image = bodyImages.find((e) => e.name === name);
    if (image) {
      return image.base64
    } else {
      return ''
    }
  }

  const deleteImage = async (name) => {
    autosave.cancel();
    setbodyImages((prev) => prev.filter((e) => (e.name || e.original_name) !== name));
    const input = document.getElementById(name);
    if (input) input.value = null;
    await get(`/peritaje/deleteimage/${id}`, {}, { 'type': 'CI', 'name': name });
  };

  const showConvertImage = async (e, name) => {
    const currentFile = e.target.files[0];
    try {
      const metadata = await uploadWithSignedUrl(currentFile, id, 'CI', 'images', name);
      const preview = URL.createObjectURL(currentFile);
      updateImages(name, { ...metadata, name, base64: preview });
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    let respo;
    const images = bodyImages.map(({ base64, ...rest }) => rest);
    const body = {
      type: 'CI',
      images
    };

    respo = await post('/peritaje/modifyinspection/pictures/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    };
  };

  useEffect(() => {
    const initForm = async () => {
      const respo = await get('/peritaje/downloadimages/CI/' + id, {});
      if (respo.success) {
        setbodyImages(respo.data);
      }
    };
    initForm();
  }, [id]);

  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">Fotos Vehiculo</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col>
          <div>
            <h2 className="fw-bold">Principal</h2>
            <div>
              <img
                alt="sin imagen"
                width={'250px'}
                src={getCurrentImage('VehicleImgPrincipal')}
              />
              <br />
              {getCurrentImage('VehicleImgPrincipal') !== '' && <Button
                variant="outline-primary"
                onClick={() => deleteImage('VehicleImgPrincipal')}
              >
                Remover
              </Button>}
            </div>
            <Form.Group>
              <Form.Control
                type="file"
                id="VehicleImgPrincipal"
                name="VehicleImgPrincipal"
                onChange={(e) => { showConvertImage(e, 'VehicleImgPrincipal'); }}
              />
            </Form.Group>
          </div>
        </Col>
        <Col>
          <div>
            <h2 className="fw-bold">Habitaculo Pasajeros</h2>
            <div>
              <img
                alt="sin imagen"
                width={'250px'}
                src={getCurrentImage('VehicleImgFront')}
              />
              <br />
              {getCurrentImage('VehicleImgFront') !== '' && <Button
                variant="outline-primary"
                onClick={() => deleteImage('VehicleImgFront')}
              >
                Remover
              </Button>}
            </div>
            <Form.Group>
              <Form.Control
                type="file"
                id="VehicleImgFront"
                name="VehicleImgFront"
                onChange={(e) => { showConvertImage(e, 'VehicleImgFront'); }}
              />
            </Form.Group>
          </div>
        </Col>
        <Col>
          <div>
            <h2 className="fw-bold">Habitaculo Motor</h2>
            <div>
              <img
                alt="sin imagen"
                width={'250px'}
                src={getCurrentImage('VehicleImgMotor')}
              />
              <br />
              {getCurrentImage('VehicleImgMotor') !== '' && <Button
                variant="outline-primary"
                onClick={() => deleteImage('VehicleImgMotor')}
              >
                Remover
              </Button>}
            </div>
            <Form.Group>
              <Form.Control
                type="file"
                id="VehicleImgMotor"
                name="VehicleImgMotor"
                onChange={(e) => { showConvertImage(e, 'VehicleImgMotor'); }}
              />
            </Form.Group>
          </div>
        </Col>
        <Col>
          <div>
            <h2 className="fw-bold">Diagonal</h2>
            <div>
              <img
                alt="sin imagen"
                width={'250px'}
                src={getCurrentImage('VehicleImgLat')}
              />
              <br />
              {getCurrentImage('VehicleImgLat') !== '' && <Button
                variant="outline-primary"
                onClick={() => deleteImage('VehicleImgLat')}
              >
                Remover
              </Button>}
            </div>
            <Form.Group>
              <Form.Control
                type="file"
                id="VehicleImgLat"
                name="VehicleImgLat"
                onChange={(e) => { showConvertImage(e, 'VehicleImgLat'); }}
              />
            </Form.Group>
          </div>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default FormVehiclePicture;
